import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
export const pdf = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(options),
    method: 'get',
})

pdf.definition = {
    methods: ["get","head"],
    url: '/reports/daily/export/pdf',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
pdf.url = (options?: RouteQueryOptions) => {
    return pdf.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
pdf.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
pdf.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pdf.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
const pdfForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
pdfForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::pdf
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:44
* @route '/reports/daily/export/pdf'
*/
pdfForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pdf.form = pdfForm

const exportMethod = {
    pdf: Object.assign(pdf, pdf),
}

export default exportMethod